import * as types from "./actionType";

const initialState = {
  fetchingTestimonialsList: false,
  testimonialLoading: false,
  testimonialsList: [],
  testimonialsListCount: 0,
  testimonialsPendingCount: 0,
  stateStatus: false,
  states: [],
  cityStatus: false,
  cities: [],
  testimonialsDetailsStatus: false,
  testimonialsDetailsData: null,
  createTestimonialStatus: false,
  updateTestimonialStatus: false,
  documentUpload: null,
  documentUploadStatus: false,
  documentRead: [],
  documentReadStatus: false,
  fetchingUpdatedDetails: false,
  updatedDetails: null,
  binaryDocument: null,
};

function testimonialReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TESTIMONIALS_LIST:
      return {
        ...state,
        fetchingTestimonialsList: true,
        testimonialLoading: true,
      };
    case types.FETCH_TESTIMONIALS_LIST_SUCCESS:
      return {
        ...state,
        fetchingTestimonialsList: false,
        testimonialLoading: false,
        testimonialsList: action.payload,
        testimonialsListCount: action.count,
        testimonialsPendingCount: action.pendingCount,
      };

    case types.FETCH_TESTIMONIALS_LIST_FAILED:
      return {
        ...state,
        fetchingTestimonialsList: false,
        testimonialLoading: false,
        testimonialsList: [],
        testimonialsListCount:0,
      };
    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.FETCH_CITY:
      return {
        ...state,
        cityStatus: true,
        cities: [],
      };
    case types.FETCH_CITY_SUCCESS: {
      return {
        ...state,
        cityStatus: false,
        cities: action.payload,
      };
    }
    case types.FETCH_CITY_FAILED: {
      return {
        ...state,
        cityStatus: false,
        cities: [],
      };
    }
    case types.FETCH_TESTIMONIALS_DETAILS: {
      return {
        ...state,
        testimonialsDetailsStatus: true,
        testimonialsDetailsData: null,
      };
    }
    case types.FETCH_TESTIMONIALS_DETAILS_SUCCESS: {
      return {
        ...state,
        testimonialsDetailsStatus: false,
        testimonialsDetailsData: action.payload,
      };
    }
    case types.FETCH_TESTIMONIALS_DETAILS_FAILED: {
      return {
        ...state,
        testimonialsDetailsStatus: false,
        testimonialsDetailsData: null,
      };
    }
    case types.CREATE_TESTIMONIAL:
      return {
        ...state,
        createTestimonialStatus: true,
      };
    case types.CREATE_TESTIMONIAL_SUCCESS: {
      return {
        ...state,
        createTestimonialStatus: false,
      };
    }
    case types.CREATE_TESTIMONIAL_FAILED: {
      return {
        ...state,
        createTestimonialStatus: false,
      };
    }

    case types.UPDATE_TESTIMONIAL:
      return {
        ...state,
        updateTestimonialStatus: true,
      };
    case types.UPDATE_TESTIMONIAL_SUCCESS: {
      return {
        ...state,
        updateTestimonialStatus: false,
      };
    }
    case types.UPDATE_TESTIMONIAL_FAILED: {
      return {
        ...state,
        updateTestimonialStatus: false,
      };
    }

    case types.UPLOAD_URL:
      return {
        ...state,
        documentUploadStatus: true,
        documentUpload: null,
      };
    case types.UPLOAD_URL_SUCCESS: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: action.payload,
      };
    }
    case types.UPLOAD_URL_FAILED: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: null,
      };
    }

    case types.READ_URL:
      return {
        ...state,
        documentReadStatus: true,
      };
    case types.READ_URL_SUCCESS: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: action.payload,
      };
    }
    case types.READ_URL_FAILED: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: [],
      };
    }

    case types.UPLOAD_BINARY_URL:
      return {
        ...state,
        binaryDocument: null,
      };
    case types.UPLOAD_BINARY_URL_SUCCESS: {
      return {
        ...state,
        binaryDocument: action.payload,
      };
    }
    case types.UPLOAD_BINARY_URL_FAILED: {
      return {
        ...state,
        binaryDocument: null,
      };
    }
    case types.TESTIMONIAL_UPDATE_DETAILS:
      return {
        ...state,
        fetchingUpdatedDetails: true,
      };
    case types.TESTIMONIAL_UPDATE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: action.payload,
      };
    case types.TESTIMONIAL_UPDATE_DETAILS_FAILED:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: null,
      };
    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        testimonialsList: [],
        fetchingTestimonialsList: false,
        stateStatus: false,
        cityStatus: false,
        documentUpload: null,
        documentRead: [],
        binaryDocument: null,
      };

    default:
      return state;
  }
}

export default testimonialReducer;
